export default __webpack_public_path__ + "static/media/J.0b02ef43.svg";